export default "__VITE_ASSET__15ed5833__$_?component__"